export class UpdateEscritoRequest {
  id!: number;  // ID del escrito, obligatorio
  descripcion!: string | null;  // Descripción del escrito, puede ser null
  titulo!: string | null;  // Título del escrito, puede ser null
  cuerpoHTML!: string | null;  // Cuerpo en HTML del escrito, puede ser null
  idEstadoEscrito!: number | null;  // ID del estado del escrito, puede ser null
  idExpediente!: number | null;  // ID del expediente, puede ser null
  fechaModificacion!: string;  // Fecha de modificación en formato date-time
  idTipoEscrito!: number | null;  // ID del tipo de escrito, puede ser null


}
